import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=34bca014&scoped=true"
import script from "./imgPreview.vue?vue&type=script&lang=js"
export * from "./imgPreview.vue?vue&type=script&lang=js"
import style0 from "./imgPreview.vue?vue&type=style&index=0&id=34bca014&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bca014",
  null
  
)

export default component.exports